import {
  AnaglyphAppConfig,
  AnaglyphClinicPrefs,
  AnaglyphOrientation,
  effectiveAnaglyphOrientation,
} from "./anaglyph_orientation";

export interface AnaglyphCalibration {
  anaglyph_orientation?: AnaglyphOrientation | null;
}

export interface FullColourAnaglyphCalibrationStatus {
  bad_anaglyph: boolean;
  no_calibration: boolean;
}

export function fullColourAnaglyphCalibrationStatus(
  calibration: AnaglyphCalibration | null,
  clinic_prefs?: AnaglyphClinicPrefs | null,
  app_config?: AnaglyphAppConfig | null,
): FullColourAnaglyphCalibrationStatus {
  const effective_orientation = effectiveAnaglyphOrientation(
    calibration?.anaglyph_orientation,
    clinic_prefs,
    app_config,
  );
  const no_calibration = calibration === null;
  return {
    bad_anaglyph:
      !no_calibration && !effective_orientation.startsWith("red"),
    no_calibration,
  };
}
